export default __webpack_public_path__ + "media/images/laptop-5a99724bc24bd3177b9fc8f71233f25a.jpg";